//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.VolumeBased25DMillingOperationBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
let d=[[[1,"AxialStepover",0,"CAM.StepoverBuilder",0],[0,"GrooveGeometry",0,"CAM.FBM.MachiningFeatureGeometry",0],[0,"LevelSequencing",1,0]],[],[]];
SPLM.CAM.GrooveMillingBuilder = class extends SPLM.CAM.VolumeBased25DMillingOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GrooveMillingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GrooveMillingBuilder.LevelSequencingType = Object.freeze({
    "CeilingToFloor" : "CeilingToFloor", "FloorToCeiling" : "FloorToCeiling", "CenterCeilingFloor" : "CenterCeilingFloor", "CenterFloorCeiling" : "CenterFloorCeiling", "CenterAlternateCeilingFirst" : "CenterAlternateCeilingFirst", "CenterAlternateFloorFirst" : "CenterAlternateFloorFirst"});

export default SPLM;